module.exports = __webpack_public_path__ + "img/display.234e597d.svg";